/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchResultOrigin = {
    ManualSearch: 'MANUAL_SEARCH',
    AutomatedSearch: 'AUTOMATED_SEARCH',
    ByNameOrId: 'BY_NAME_OR_ID'
} as const;
export type SourcingSearchResultOrigin = typeof SourcingSearchResultOrigin[keyof typeof SourcingSearchResultOrigin];


export function instanceOfSourcingSearchResultOrigin(value: any): boolean {
    for (const key in SourcingSearchResultOrigin) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchResultOrigin, key)) {
            // @ts-ignore
            if (SourcingSearchResultOrigin[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchResultOriginFromJSON(json: any): SourcingSearchResultOrigin {
    return SourcingSearchResultOriginFromJSONTyped(json, false);
}

export function SourcingSearchResultOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchResultOrigin {
    return json as SourcingSearchResultOrigin;
}

export function SourcingSearchResultOriginToJSON(value?: SourcingSearchResultOrigin | null): any {
    return value as any;
}

